import globalSlice from "./global.slice";
import userSlice from "./userSlice";
import appStateSlice from "./app.state.slice";
import submittedPendingSlice from "./submitted.pending.slice";
import inquiringSubmittedSlice from "./submitted.inquiring.slice";
import approvedSubmittedSlice from "./submitted.approved.slice";
import copywriteridashboardPendingtitiling from "./copywriteridashboardPendingtitiling.slice";
import submittedDuplicationSlice from "./submitted.duplicate.slice";
import submittedRejectedSlice from "./submitted.rejected.slice ";
import submittedDeletedSlice from "./submitted.deleted.slice";
import websiteSubmittedSlice from "./submitted.website.slice";
import contentBuyerSlice from "./contentBuyer.slice";
import releasedVideoSlice from "./released.video.slice";
import dashboardUnreachable from "./dashboard.unreachable.slice";
import dashboardTitled from "./dashboard.titled.slice";
import dashboardRevisedTitled from "./dashboard.revised.titled";
import dashboardUntitled from "./dashboard.untitled.slice";
import dashboardPendingRevision from "./dashboard.pending.revision";
import dashboardPendingPublication from "./dashboard.pending.publication";
import dashboardApproveApproveSlice from "./dashboard.approve.approve.slice";
import dashboardRejectedRejectedSlice from "./dashboard.rejected.rejected.slice";
import dashboardWebsiteWebsiteSlice from "./dashboard.website.website.slice";
import dashboardWebsiteApprovedSlice from "./dashboard.website.approved.slice";
import dashboardWebsiteRejectedSlice from "./dashboard.website.rejected.slice";
import dashboardApproveRejectedSlice from "./dashboard.approve.rejected.slice";
import dashboardApproveWebsiteSlice from "./dashboard.approve.website.slice";
import dashboardRejectedApproveSlice from "./dashboard.rejected.approve.slice";
import dashboardRejectedWebsiteSlice from "./dashboard.rejected.website.slice";
import submittedPendingTitlingSlice from "./submittedPendingTitlingSlice";
import pendingPublicationSlice from "./pendingpublication.slice";
import publishedCleareddSlice from "./cleared.published.slice";
import dashboardPurchaseWebsiteSlice from "./dashboard.purchase.website.slice";
import dashboardPurchasePlatformSlice from "./dashboard.purchase.platform";
import qcConfirmApproveApproveSlice from "./qc.confirm.approved.approved.slice";
import managerConfirmedApprovedApprovedSlice from "./managerConfirmedApprovedApproved.slice";

import qcConfirmwebsitewebsiteSlice from "./qc.confirm.website.website.slice";
import searchQuerySlice from "./searchQuery.slice";

import searchQueryCopywritersSlice from "./searchQueryCopywriters.slce";

import qcReviewApproveSlice from "./qc/qc.review.approve.slice";
import qcReviewWebsiteSlice from "./qc/qc.review.website.slice";
import qcReviewRejectedSlice from "./qc/qc.review.rejected.slice";
import qcVerifiedApprovedApprovedSlice from "./qc/qc.verified.approved.approved.slice";
import qcVerifiedWebsiteWebsiteSlice from "./qc/qc.verified.website.website.slice";
import qcVerifiedRejectedRejectedSlice from "./qc/qc.verified.rejected.rejected.slice";
import qcAwaitApprovedSlice from "./qc/qc.await.approved.slice";
import qcAwaitWebsiteSlice from "./qc/qc.await.website.slice";
import qcAwaitRejectedSlice from "./qc/qc.await.rejected.slice";
import qcSubmittedPendingSlice from "./qc/qc.submitted.pending.slice";
import qcSubmittedInquiringSlice from "./qc/qc.submitted.inquiring.slice";
import qcSubmittedDuplicateSlice from "./qc/qc.submitted.duplicate.slice";
import qcVerifiedApprovedRejectedSlice from "./qc/qc.verified.approved.rejected.slice";
import qcVerifiedApprovedWebsiteSlice from "./qc/qc.verified.approved.website.slice";
import qcVerifiedRejectedApprovedSlice from "./qc/qc.verified.rejected.approved.slice";
import qcVerifiedRejectedWebsiteSlice from "./qc/qc.verified.rejected.website.slice";
import qcVerifiedWebsiteApprovedSlice from "./qc/qc.verified.website.approved.slice";
import qcVerifiedWebsiteRejectedSlice from "./qc/qc.verified.website.rejected.slice";
import qcDashboardPendingTitlingSlice from "./qc/qc.dashboard.pending.titling.slice";
import editorSearchQuerySlice from "./editor/editorSearchQuery.slice";
import editorPendingPublicationSlice from "./editor/editorPendingPublication.slice";
import editorPublishVideoSlice from "./editor/editorPublishVideo.slice" 
const rootReducer = {
  userSlice,
  globalSlice,
  appStateSlice,
  dashboardUnreachable,
  dashboardRevisedTitled,
  dashboardTitled,
  dashboardUntitled,
  dashboardPendingRevision,
  dashboardPendingPublication,
  dashboardApproveApproveSlice,
  dashboardRejectedRejectedSlice,
  dashboardWebsiteWebsiteSlice,
  dashboardApproveRejectedSlice,
  dashboardApproveWebsiteSlice,
  dashboardRejectedApproveSlice,
  dashboardRejectedWebsiteSlice,
  dashboardWebsiteApprovedSlice,
  dashboardWebsiteRejectedSlice,
  submittedPendingSlice,
  inquiringSubmittedSlice,
  approvedSubmittedSlice,
  copywriteridashboardPendingtitiling,
  submittedDuplicationSlice,
  submittedRejectedSlice,
  submittedDeletedSlice,
  websiteSubmittedSlice,
  contentBuyerSlice,
  releasedVideoSlice,
  submittedPendingTitlingSlice,
  pendingPublicationSlice,
  publishedCleareddSlice,
  dashboardPurchaseWebsiteSlice,
  qcConfirmApproveApproveSlice,
  managerConfirmedApprovedApprovedSlice,
  qcConfirmwebsitewebsiteSlice,
  dashboardPurchasePlatformSlice,
  searchQuerySlice,
  qcReviewApproveSlice: qcReviewApproveSlice,
  qcReviewWebsiteSlice: qcReviewWebsiteSlice,
  qcReviewRejectedSlice: qcReviewRejectedSlice,
  qcVerifiedApprovedApprovedSlice: qcVerifiedApprovedApprovedSlice,
  qcVerifiedWebsiteWebsiteSlice: qcVerifiedWebsiteWebsiteSlice,
  qcVerifiedRejectedRejectedSlice: qcVerifiedRejectedRejectedSlice,
  qcAwaitApprovedSlice: qcAwaitApprovedSlice,
  qcAwaitWebsiteSlice: qcAwaitWebsiteSlice,
  qcAwaitRejectedSlice: qcAwaitRejectedSlice,
  qcSubmittedPendingSlice: qcSubmittedPendingSlice,
  qcSubmittedInquiringSlice: qcSubmittedInquiringSlice,
  qcSubmittedDuplicateSlice: qcSubmittedDuplicateSlice,
  qcVerifiedApprovedRejectedSlice: qcVerifiedApprovedRejectedSlice,
  qcVerifiedApprovedWebsiteSlice: qcVerifiedApprovedWebsiteSlice,
  qcVerifiedRejectedApprovedSlice: qcVerifiedRejectedApprovedSlice,
  qcVerifiedRejectedWebsiteSlice: qcVerifiedRejectedWebsiteSlice,
  qcVerifiedWebsiteApprovedSlice: qcVerifiedWebsiteApprovedSlice,
  qcVerifiedWebsiteRejectedSlice: qcVerifiedWebsiteRejectedSlice,
  qcDashboardPendingTitlingSlice: qcDashboardPendingTitlingSlice,
  editorSearchQuerySlice,
  searchQueryCopywritersSlice:searchQueryCopywritersSlice,
  editorPendingPublicationSlice:editorPendingPublicationSlice,
  editorPublishVideoSlice
};

export default rootReducer;
